import { Spinner as ReactSpinner } from '@a-ui/react';
import React from 'react';
import ReactModal from 'react-modal';
import { translate } from '../../i18n';
import './style.scss';

interface LoadingScreenProps {}

const LoadingScreen: React.FC<LoadingScreenProps> = () => {
  return (
    <ReactModal isOpen overlayClassName="ckp-a-loading__overlay" className="ckp-a-loading">
      <ReactSpinner size="large" label={translate('common.loading')} />
    </ReactModal>
  );
};

export default LoadingScreen;
